export default __webpack_public_path__ + "static/media/kienlongbank.e21e955b.png";